import LandingNav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Modules from "@/components/landing/Modules";
import Signals from "@/components/landing/Signals";
import Personas from "@/components/landing/Personas";
import Principles from "@/components/landing/Principles";
import WaitlistForm from "@/components/landing/WaitlistForm";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-obsidian text-ink"
    >
      <LandingNav />
      <Hero />
      <Problem />
      <Modules />
      <Signals />
      <Personas />
      <Principles />
      <WaitlistForm />
      <Footer />
    </main>
  );
}
